import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import VueGtm from 'vue-gtm';
import Vue2TouchEvents from 'vue2-touch-events';
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import vClickOutside from 'v-click-outside';
import 'normalize.css/normalize.css';
import { Auth0Plugin } from './auth';
import APP_UTILITIES from './utilities/commonFunctions';

Vue.use(ElementUI, { size: 'small' });

Vue.use(vClickOutside);
Vue.use(Vue2TouchEvents);
Vue.directive('telnumberformat', {
  bind: function(el: any, binding: any) {
    binding.def.handleKeyUp(el);
  },
  update: function(el: any, binding: any) {
    binding.def.handleKeyUp(el);
  },
  inserted: (el: any, binding: any) => {
    el.addEventListener('keyup', (evt: any) => {
      if (
        evt.keyCode == 37 ||
        evt.keyCode == 38 ||
        evt.keyCode == 39 ||
        evt.keyCode == 40
      ) {
        return;
      }
      binding.def.handleKeyUp(el);
    });
  },
  handleKeyUp: (input: any) => {
    if (input.nodeName == 'DIV' && input.querySelector('input')) {
      input = input.querySelector('input');
    }
    let val = input.value;
    let cursorIndex = input.selectionStart;

    const objReg = /\D/;
    for (let i = 0; i < cursorIndex; i++) {
      const sub = val.substr(i, 1);
      const test = objReg.test(sub.toString());
      if (test) {
        cursorIndex--;
      }
    }

    val = val.replace(/\D/g, '').substring(0, 10);

    if (cursorIndex < 3) {
      cursorIndex += 1;
    }
    else if (cursorIndex > 2 && cursorIndex < 6) {
      cursorIndex += 3;
    }
    else {
      cursorIndex += 4;
    }
    const zip = val && val.substring(0, 3);
    const middle = val && val.substring(3, 6);
    const last = val && val.substring(6, 10);
    if (val.length == 0 || val.charAt(0) == '0') {
      val = '';
    }
    else if (val.length < 4) {
      val = `(${zip}`;
    }
    else if (val.length < 7) {
      val = `(${zip}) ${middle}`;
    }
    else {
      val = `(${zip}) ${middle}-${last}`;
    }

    input.value = val;
    const phone_error = document.querySelector('#phone_validation');
    if (phone_error) {
      phone_error.remove();
    }
  },
} as any);

Vue.use(VueGtm, {
  id:
    process.env
      .VUE_APP_GTM_CODE /* ,// 'GTM-T95XJMW'
  queryParams: {
    gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
    gtm_preview:'env-4',
    gtm_cookies_win:'x'
  } */,
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router,
  ignoredViews: [],
  trackOnNextTick: false,
});

Vue.use(vClickOutside);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  onRedirectCallback: (appState: any) => {
    if (appState) {
      APP_UTILITIES.setCookie('accountDesign', JSON.stringify(appState), 1);
      localStorage.setItem('accountDesign', JSON.stringify(appState));
    }
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
